import * as styles from './TextInput.module.css'

import React, { useCallback } from 'react'
import classNames from 'classnames'

interface Props extends React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> {
  accent?: boolean
  unit?: string
  onClear?(): void
  onReturn?(event: React.KeyboardEvent<HTMLInputElement>): void
}

export const TextInput: React.FC<Props> = (props) => {
  const { accent, unit, onClear, onReturn, ...inputProps } = props

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (onReturn != null && event.key === 'Enter') {
        onReturn(event)
      } else {
        props.onKeyDown?.(event)
      }
    },
    [onReturn, props],
  )

  return (
    <div className={styles.container}>
      <div>
        <input
          type="text"
          {...inputProps}
          className={classNames(styles.input, {
            [styles.accent]: accent,
            [styles.withUnit]: unit != null,
          })}
          onKeyDown={handleKeyDown}
        />

        {onClear != null && props.value != null && props.value != '' && (
          <button
            type="button"
            onClick={onClear}
            className={styles.clearButton}
          >
            &times;
          </button>
        )}
      </div>

      {unit != null && <div className={styles.unit}>{unit}</div>}
    </div>
  )
}
